import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ARFInterface {
  formType: "1" | "2" | "3";
  formDetail: ARFDetail | null;
}

interface ARFDetail {
  name: string;
  date: string;
  time: string;
  noPeople: string;
  subject: string;
  message: string;
}

const initialState: ARFInterface = {
  formType: "1",
  formDetail: null,
};
const ARFReducer = createSlice({
  name: "arf",
  initialState,
  reducers: {
    setARFFormType: (state, action: PayloadAction<"1" | "2" | "3">) => {
      state.formType = action.payload;
    },

    submitARFDetail: (state, action: PayloadAction<ARFDetail | null>) => {
      state.formDetail = action.payload;
    },
  },
});

export const { setARFFormType, submitARFDetail } = ARFReducer.actions;
export default ARFReducer.reducer;
